import * as Yup from "yup";
import { RelodeApiError } from "./";
import { ApplicationError, RelodeErrorBase } from "./types";

export const createError = (error: Error | RelodeApiError, message: string) => {
    if (!(error instanceof Error)) {
        const appError = ApplicationError.fromUnknown(message);
        appError.origin = message;
        return appError;
    }

    if (error instanceof RelodeErrorBase) {
        error.origin = message;
        return error;
    } else {
        const appError = ApplicationError.fromError(error);
        appError.origin = message;
        return appError;
    }
};

export const validateSchema = <T extends object>(
    schema: Yup.ObjectSchema<T>,
    values: T,
    options?: Yup.ValidateOptions
): Yup.ValidationError[] => {
    let result: Yup.ValidationError[] = [];

    const opts = options || { abortEarly: false };
    try {
        schema.validateSync(values, opts);
    } catch (err) {
        if (err instanceof Yup.ValidationError) {
            if (!err.inner || err.inner.length === 0) {
                result.push(err);
            } else {
                result = err.inner;
            }
        }
    }

    return result;
};
